export default __webpack_public_path__ + "static/media/F1_9.df5aee97.png";